import React from 'react';

// Global SLDS Studio footer — shown on every mockup.
// Fixed-position so it clears any viewport-height layouts. In dev, sits above
// the Datadog status banner; in prod, sits at bottom:0.

const GithubIcon = ({ size = 14 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-hidden="true"
    style={{ flexShrink: 0 }}
  >
    <path d="M12 .5C5.73.5.5 5.73.5 12c0 5.08 3.29 9.38 7.86 10.9.58.1.79-.25.79-.56 0-.28-.01-1.02-.02-2-3.2.7-3.87-1.54-3.87-1.54-.52-1.33-1.28-1.68-1.28-1.68-1.05-.72.08-.7.08-.7 1.16.08 1.77 1.2 1.77 1.2 1.03 1.77 2.7 1.26 3.36.96.1-.75.4-1.26.73-1.55-2.55-.29-5.24-1.28-5.24-5.7 0-1.26.45-2.29 1.19-3.1-.12-.3-.52-1.48.11-3.08 0 0 .97-.31 3.18 1.18.92-.26 1.9-.38 2.88-.39.98 0 1.96.13 2.88.39 2.2-1.49 3.17-1.18 3.17-1.18.63 1.6.23 2.78.11 3.08.74.81 1.19 1.84 1.19 3.1 0 4.43-2.7 5.41-5.26 5.69.41.35.78 1.05.78 2.12 0 1.53-.01 2.76-.01 3.14 0 .31.21.67.8.56C20.22 21.37 23.5 17.08 23.5 12 23.5 5.73 18.27.5 12 .5z" />
  </svg>
);

const RepoLink = ({ slug }) => (
  <a
    href={`https://github.com/${slug}`}
    target="_blank"
    rel="noopener noreferrer"
    style={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: 6,
      padding: '3px 10px',
      background: '#ffffff',
      color: '#706e6b',
      border: '1px solid #dddbda',
      borderRadius: 999,
      fontSize: 11,
      fontWeight: 400,
      lineHeight: 1.4,
      fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace',
      textDecoration: 'none',
      transition: 'all 120ms',
      whiteSpace: 'nowrap',
    }}
    onMouseEnter={e => {
      e.currentTarget.style.borderColor = '#080707';
      e.currentTarget.style.color = '#080707';
    }}
    onMouseLeave={e => {
      e.currentTarget.style.borderColor = '#dddbda';
      e.currentTarget.style.color = '#706e6b';
    }}
  >
    <GithubIcon />
    {slug}
  </a>
);

export const SITE_FOOTER_HEIGHT = 40;
export const DATADOG_BANNER_HEIGHT = 36;

export default function SiteFooter() {
  const isDev = process.env.NODE_ENV === 'development';
  return (
    <footer
      style={{
        position: 'fixed',
        left: 0,
        right: 0,
        bottom: isDev ? DATADOG_BANNER_HEIGHT : 0,
        zIndex: 9998, // Just under the Datadog banner's 9999
        height: SITE_FOOTER_HEIGHT,
        borderTop: '1px solid #dddbda',
        background: '#f7f7f8',
        padding: '0 24px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: 12,
        flexWrap: 'wrap',
        fontSize: 11,
        color: '#706e6b',
      }}
    >
      <span>
        SLDS Studio — a{' '}
        <a
          href="https://revenuepoint.com"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: 'inherit',
            textDecoration: 'none',
            borderBottom: '1px solid #c9c7c5',
            paddingBottom: 1,
            transition: 'color 120ms, border-color 120ms',
          }}
          onMouseEnter={e => {
            e.currentTarget.style.color = '#080707';
            e.currentTarget.style.borderBottomColor = '#080707';
          }}
          onMouseLeave={e => {
            e.currentTarget.style.color = 'inherit';
            e.currentTarget.style.borderBottomColor = '#c9c7c5';
          }}
        >
          RevenuePoint
        </a>{' '}
        project
      </span>
      <RepoLink slug="revenuepoint/slds-studio" />
    </footer>
  );
}
